import React from "react";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { READ_CASE_STUDY_CTA_LABEL } from "./CreatorCaseStudies.constants";
import {
  formatCtaWithArrow,
  getCardBorderClass,
} from "./CreatorCaseStudies.utils";
import { CASE_STUDY_CARD_PROPS } from "./CaseStudyCard.types";

export const CaseStudyCard = ({ card, onCardClick }) => {
  const {
    category,
    name,
    subtitle,
    description,
    metrics,
    photoUrl,
    linkUrl,
    isFeatured,
  } = card;

  const handleClick = () => {
    if (onCardClick) {
      onCardClick(linkUrl);
    }
  };

  const borderClassName = getCardBorderClass(isFeatured);

  return (
    <div
      className={`tw-bg-white tw-rounded-2xl tw-border tw-border-solid ${borderClassName} tw-overflow-hidden tw-flex tw-flex-col tw-justify-between tw-transition-all tw-duration-200 hover:tw-shadow-md`}
    >
      <div>
        {/* Top Media / Photo Box - Full bleed with rounded top */}
        <div className="tw-relative tw-w-full tw-h-64 sm:tw-h-72 tw-overflow-hidden tw-bg-[#EAEAF3] tw-flex tw-items-center tw-justify-center">
          {/* Category Chip Badge */}
          {category && (
            <div className="tw-absolute tw-top-4 tw-left-4 tw-bg-white tw-text-[#4E39DF] tw-text-xs tw-font-bold tw-px-3.5 tw-py-1.5 tw-rounded-full tw-shadow-sm tw-z-10">
              {category}
            </div>
          )}

          {photoUrl ? (
            <ExlyImage
              src={photoUrl}
              alt={name}
              className="tw-w-full tw-h-full tw-object-cover"
            />
          ) : null}
        </div>

        {/* Content Body */}
        <div className="tw-p-5 sm:tw-p-6">
          {/* Creator Name & Subtitle */}
          <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-m-0">
            {name}
          </h3>
          <p className="tw-text-xs sm:tw-text-sm tw-text-slate-400 tw-font-normal tw-mt-0 tw-pb-2">
            {subtitle}
          </p>

          {/* Description */}
          <p className="tw-text-xs sm:tw-text-sm tw-text-slate-600 tw-leading-relaxed tw-m-0">
            {description}
          </p>
        </div>
      </div>

      {/* Bottom Metrics & CTA */}
      <div className="tw-px-5 sm:tw-px-6 tw-pb-6">
        {/* Metrics Row (if present) */}
        {metrics && metrics.length > 0 && (
          <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-pt-2 tw-mb-4 tw-border-t tw-border-l-0 tw-border-r-0 tw-border-b-0 tw-border-solid tw-border-slate-100">
            {metrics.map((metric) => (
              <div key={metric.id}>
                <div className="tw-text-base sm:tw-text-lg tw-font-extrabold tw-text-[#4E39DF] tw-leading-tight">
                  {metric.value}
                </div>
                <div className="tw-text-[11px] tw-text-slate-500 tw-leading-tight tw-mt-0.5">
                  {metric.label}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Read Case Study CTA Link */}
        <button
          type="button"
          onClick={handleClick}
          className="tw-text-sm tw-font-bold tw-text-[#4E39DF] hover:tw-text-[#3724B8] tw-flex tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-p-0 tw-cursor-pointer tw-transition-colors"
        >
          {formatCtaWithArrow(READ_CASE_STUDY_CTA_LABEL)}
        </button>
      </div>
    </div>
  );
};

CaseStudyCard.propTypes = CASE_STUDY_CARD_PROPS;

CaseStudyCard.defaultProps = {
  onCardClick: null,
};
